<template>
  <main class="page trial-page">
    <section class="form-card amount-card">
      <label for="amount">分期金额</label>
      <div class="amount-input">
        <input
          id="amount"
          v-model="amount"
          type="number"
          inputmode="decimal"
          placeholder="申请金额需大于500元"
        />
        <button
          v-if="amount"
          type="button"
          class="clear-input"
          aria-label="清空分期金额"
          @click.prevent="amount = ''"
        >
          <van-icon name="clear" />
        </button>
      </div>
    </section>

    <section class="form-card repayment-card">
      <button type="button" class="form-row" @click="openCyclePicker">
        <span>还款期数</span>
        <span class="row-value">{{ cycle || "请选择" }}<van-icon name="arrow" /></span>
      </button>
      <div class="form-row">
        <span>还款计划</span>
        <button
          type="button"
          class="repayment-plan-trigger"
          aria-label="查看还款计划"
          @click="openRepaymentPlan"
        >
          <van-icon name="arrow" />
        </button>
      </div>
    </section>

    <section class="form-card details-card">
      <label class="form-row">
        <span>首付金额</span>
        <input v-model="downPayment" type="number" inputmode="decimal" placeholder="请输入首付金额" />
        <button
          v-if="downPayment"
          type="button"
          class="clear-input"
          aria-label="清空首付金额"
          @click.prevent="downPayment = ''"
        >
          <van-icon name="clear" />
        </button>
      </label>
      <button type="button" class="form-row" @click="openProjectPicker">
        <span>项目名称</span>
        <span class="row-value">{{ projectName || "请选择" }}<van-icon name="arrow" /></span>
      </button>
      <button type="button" class="form-row" @click="showProduct = true">
        <span>活动产品</span>
        <span class="row-value">{{ activityProduct || "请选择" }}<van-icon name="arrow" /></span>
      </button>
      <label class="form-row">
        <span>推荐人工号</span>
        <input maxlength="4" v-model="referrerNo" type="number" placeholder="请输入推荐人工号" />
        <button
          v-if="referrerNo"
          type="button"
          class="clear-input"
          aria-label="清空推荐人工号"
          @click.prevent="referrerNo = ''"
        >
          <van-icon name="clear" />
        </button>
      </label>
    </section>

    <button type="button" class="confirm-button" @click="next">确定</button>
    <button type="button" class="exit-button" aria-label="退出" @click="exit">
      <img src="../assets/images/tuichu.png" alt="" />
    </button>

    <van-popup v-model="showCycle" position="bottom" class="cycle-popup">
      <van-picker
        title="还款期数"
        show-toolbar
        :columns="cycleOptions"
        :default-index="cycleOptions.indexOf(cycle || 12)"
        item-height="40"
        visible-item-count="5"
        @confirm="confirmCycle"
        @cancel="showCycle = false"
      />
    </van-popup>
    <van-popup
      v-model="showRepaymentPlan"
      position="bottom"
      class="repayment-plan-popup"
    >
      <header class="repayment-plan-header">
        <h2>还款计划</h2>
        <button
          type="button"
          aria-label="关闭还款计划"
          @click="showRepaymentPlan = false"
        >
          <van-icon name="cross" />
        </button>
      </header>
      <div class="repayment-plan-scroll">
        <table class="repayment-plan-table">
          <tbody>
            <tr v-for="item in repaymentSchedule" :key="item.period">
              <td style="font-weight: 500;">{{ item.period }}</td>
              <td style="font-weight: bold;">¥ {{ item.amount }}</td>
              <td style="color: #c8c9cc;">{{ item.date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="repayment-plan-note">
        <span class="rate-warning-icon">!</span>
        <span>贷款年化利率：20.12% （仅供参考，请以审核通过后利率为准）</span>
      </p>
    </van-popup>
    <van-popup v-model="showProject" position="bottom" class="project-popup">
      <header class="project-popup-header">
        <button type="button" @click="showProject = false">取消</button>
        <h2>项目名称</h2>
        <button type="button" class="project-confirm" @click="confirmProjects">确认</button>
      </header>
      <div class="project-picker-body">
        <nav class="project-categories">
          <button
            v-for="(category, index) in projectCategories"
            :key="category.name"
            type="button"
            :class="{ active: activeProjectCategory === index }"
            @click="activeProjectCategory = index"
          >
            {{ category.name }}
          </button>
        </nav>
        <div class="project-options">
          <button
            v-for="item in projectCategories[activeProjectCategory].items"
            :key="item"
            type="button"
            :class="{ selected: draftProjects.includes(item) }"
            @click="toggleProject(item)"
          >
            <span>{{ item }}</span>
            <van-icon v-if="draftProjects.includes(item)" name="success" />
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showProduct" position="bottom" class="cycle-popup">
      <van-picker
        title="活动产品"
        show-toolbar
        :columns="productOptions"
        :default-index="productOptions.indexOf(activityProduct || '产品一')"
        item-height="40"
        visible-item-count="5"
        @confirm="confirmProduct"
        @cancel="showProduct = false"
      />
    </van-popup>
  </main>
</template>

<script>
export default {
  name: "TrialByInstallments",
  data: () => ({
    amount: "18600",
    cycle: "12期",
    downPayment: "3600",
    projectName: "光子嫩肤、皮肤清洁",
    selectedProjects: ["光子嫩肤", "皮肤清洁"],
    draftProjects: ["光子嫩肤", "皮肤清洁"],
    activeProjectCategory: 0,
    activityProduct: "产品三",
    referrerNo: "4827",
    showCycle: false,
    showRepaymentPlan: false,
    showProject: false,
    showProduct: false,
    cycleOptions: ['3期', '6期', '9期', '12期'],
    projectCategories: [
      { name: "眼部整形", items: ["祛眼袋", "丰卧蚕", "开眼角", "双眼皮", "提眉", "丰眉弓"] },
      { name: "鼻部整形", items: ["隆鼻", "鼻尖整形", "鼻翼缩小", "鼻综合", "鼻修复"] },
      { name: "唇部整形", items: ["丰唇", "唇形调整", "厚唇改薄", "唇部修复"] },
      { name: "耳部整形", items: ["招风耳矫正", "耳垂整形", "耳再造", "耳部修复"] },
      { name: "面部整形", items: ["面部填充", "下颌整形", "颧骨整形", "面部提升"] },
      { name: "皮肤美容", items: ["光子嫩肤", "皮肤清洁", "祛斑", "祛痘", "紧致抗衰"] },
    ],
    productOptions: ["产品一", "产品二", "产品三", "产品四"],
  }),
  computed: {
    repaymentPlan() {
      if (!this.amount || !this.cycle) return "";
      const monthly = Number(this.amount) / parseInt(this.cycle, 10);
      return `每期 ¥${monthly.toFixed(2)}`;
    },
    repaymentSchedule() {
      const periods = parseInt(this.cycle, 10);
      const amount = Number(this.amount);
      if (!periods || !amount) return [];

      const monthly = (amount / periods).toFixed(2);
      const today = new Date();
      return Array.from({ length: periods }, (_, index) => {
        const date = new Date(
          today.getFullYear(),
          today.getMonth() + index + 1,
          today.getDate()
        );
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return {
          period: index + 1 + '期',
          amount: monthly,
          date: `${year}-${month}-${day}`,
        };
      });
    },
  },
  methods: {
    openRepaymentPlan() {
      if (!this.cycle) return this.$toast("请先选择还款期数");
      this.showRepaymentPlan = true;
    },
    openCyclePicker() {
      if (!this.amount) return this.$toast("请输入分期金额");
      if (Number(this.amount) < 500)
        return this.$toast("分期金额需大于等于500元");
      this.showCycle = true;
    },
    exit() {
      this.$router.push("/login");
    },
    confirmCycle(value) {
      this.cycle = value;
      this.showCycle = false;
      this.showRepaymentPlan = true;
    },
    openProjectPicker() {
      this.draftProjects = [...this.selectedProjects];
      this.showProject = true;
    },
    toggleProject(item) {
      const index = this.draftProjects.indexOf(item);
      if (index === -1) this.draftProjects.push(item);
      else this.draftProjects.splice(index, 1);
    },
    confirmProjects() {
      this.selectedProjects = [...this.draftProjects];
      this.projectName = this.selectedProjects.join("，");
      this.showProject = false;
    },
    confirmProduct(value) {
      this.activityProduct = value;
      this.showProduct = false;
    },
    next() {
      if (Number(this.amount) < 500) return this.$toast("分期金额需大于500元");
      if (!this.cycle) return this.$toast("请选择还款期数");
      if (!this.downPayment) return this.$toast("请输入首付金额");
      if (!this.projectName) return this.$toast("请选择项目名称");
      if (!this.activityProduct) return this.$toast("请选择活动产品");
      if (!this.referrerNo) return this.$toast("请填写推荐人工号");
      this.$router.push("/consumptionVoucher");
    },
  },
};
</script>

<style lang="scss" scoped>
.trial-page {
  position: relative;
  min-height: 100vh;
  padding: 12px;
  background: #f5f7f9;
  color: #3f4b5c;
}
.form-card {
  overflow: hidden;
  margin-bottom: 35px;
  background: #fff;
  border-radius: 7px;
}
.amount-card {
  padding: 14px 10px 12px;
}
.amount-card label {
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}
.amount-input {
  display: flex;
  align-items: center;
  border-bottom: 3px solid #d3936a;
}
.amount-card input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #2a3853;
  font-size: 40px;
  font-weight: bold;
}
.amount-card input::placeholder {
  color: #c8c9cc;
  font-size: 18px;
  font-weight: normal !important;
}
.repayment-card {
  margin-bottom: 50px;
}
.form-row {
  display: flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border: 0;
  border-bottom: 1px solid #f1f2f3;
  outline: none;
  background: transparent;
  color: #3f4b5c;
  font: inherit;
  font-size: 17px;
  text-align: left;
}
.form-row > span:first-child {
  font-weight: bold;
}
.form-row:last-child {
  border-bottom: 0;
}
.row-value {
  display: flex;
  max-width: 65%;
  align-items: center;
  color: #d3936a;
  font-weight: bold;
  text-align: right;
}
.row-value .van-icon {
  margin-left: 2px;
}
.repayment-plan-trigger {
  display: flex;
  width: 65%;
  align-self: stretch;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  border: 0;
  background: transparent;
  color: #788292;
  font: inherit;
  font-weight: bold;
  text-align: right;
}
.repayment-plan-trigger .van-icon {
  margin-left: 2px;
  color: #d3936a;
}
.form-row input {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #3f4b5c;
  font-size: 17px;
  text-align: right;
}
.form-row input::placeholder {
  color: #c8c9cc;
}
.clear-input {
  display: flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #c8c9cc;
  font-size: 16px;
}
.confirm-button {
  width: 100%;
  height: 50px;
  margin-top: 20px;
  border: 0;
  border-radius: 6px;
  background: linear-gradient(90deg, #e1a379 0%, #b36e47 100%);
  box-shadow: none;
  color: #fff;
  font-size: 17px;
}
.exit-button {
  position: fixed;
  right: max(13px, calc((100vw - 420px) / 2 + 13px));
  bottom: 80px;
  display: flex;
  width: 55px;
  height: 55px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #eceeef;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(42, 56, 83, 0.08);
}
.exit-button img {
  display: block;
  width: 55px;
  height: 55px;
  object-fit: contain;
}
.cycle-popup ::v-deep .van-picker__toolbar {
  height: 52px;
}
.cycle-popup ::v-deep .van-picker__title {
  color: #3f4b5c;
  font-size: 20px;
}
.cycle-popup ::v-deep .van-picker__cancel {
  padding: 0 20px;
  color: #8f9daf;
  font-size: 16px;
}
.cycle-popup ::v-deep .van-picker__confirm {
  padding: 0 20px;
  color: #d3936a;
  font-size: 16px;
}
.cycle-popup ::v-deep .van-picker-column__item {
  color: #999;
  font-size: 16px;
}
.cycle-popup ::v-deep .van-picker-column__item--selected {
  color: #000;
}
.cycle-popup ::v-deep .van-picker__frame::after {
  border-color: #f6f8f9;
}
.repayment-plan-popup {
  color: #3f4b5c;
}
.repayment-plan-header {
  position: relative;
  height: 55px;
  background: #f5f7f9;
}
.repayment-plan-header h2 {
  margin: 0;
  padding-top: 14px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.repayment-plan-header button {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 46px;
  height: 46px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #788292;
  font-size: 18px;
}
.repayment-plan-scroll {
  max-height: 240px;
  overflow-y: auto;
}
.repayment-plan-table {
  width: 100%;
  padding: 0 20px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 17px;
  text-align: center;
}
.repayment-plan-table td {
  width: 33.333%;
  height: 40px;
  padding: 0;
  font-weight: 400;
}
.repayment-plan-table td:first-child {
  text-align: left;
}
.repayment-plan-table td:last-child {
  text-align: right;
}
.repayment-plan-note {
  display: flex;
  align-items: flex-start;
  margin: 0;
  padding: 31px 20px 20px;
  font-size: 10px;
  line-height: 16px;
}
.rate-warning-icon {
  color: #788292;
  display: inline-flex;
  width: 12px;
  height: 12px;
  align-items: center;
  justify-content: center;
  flex: 0 0 12px;
  margin: 1px 5px 0 0;
  border: 1px solid currentColor;
  border-radius: 50%;
  font-size: 8px;
  font-weight: bold;
  line-height: 1;
}
.project-popup {
  height: 365px;
  color: #26374d;
}
.project-popup-header {
  display: flex;
  height: 52px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef0f2;
}
.project-popup-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}
.project-popup-header button {
  padding: 0 18px;
  border: 0;
  background: transparent;
  color: #8f9daf;
  font-size: 16px;
}
.project-popup-header .project-confirm {
  color: #d3936a;
}
.project-picker-body {
  display: flex;
  height: calc(100% - 52px);
}
.project-categories {
  width: 33%;
  overflow-y: auto;
  background: #f6f7f8;
}
.project-categories button,
.project-options button {
  width: 100%;
  height: 48px;
  border: 0;
  background: transparent;
  color: #26374d;
  font-size: 15px;
  text-align: left;
}
.project-categories button {
  padding: 0 10px;
}
.project-categories button.active {
  border-left: 3px solid #d3936a;
  background: #fff;
  color: #d3936a;
}
.project-options {
  flex: 1;
  overflow-y: auto;
}
.project-options button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.project-options button.selected {
  color: #d3936a;
}
</style>
